module.exports = __webpack_public_path__ + "static/media/døy.be062d36.m4a";